<script setup>
import CustomInput from '@/components/Form/CustomInput.vue'
import CustomCheckbox from '@/components/Form/CustomCheckbox.vue'
import {useGlobalStore} from '@/store'
import { watch, computed } from 'vue'

const globalStore = useGlobalStore()
const personalDataFirstname = computed(() => {
  return globalStore.stepTwo.personalData.firstname
})
const personalDataLastname = computed(() => {
  return globalStore.stepTwo.personalData.lastname
})
const isOtherDeliveryRecipient = computed(() => {
  return globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient
})

watch(personalDataFirstname, (newValue) => {
  if (!globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient) {
    globalStore.stepTwo.deliveryData.firstname = newValue
  }
})

watch(personalDataLastname, (newValue) => {
  if (!globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient) {
    globalStore.stepTwo.deliveryData.lastname = newValue
  }
})

watch(isOtherDeliveryRecipient, (newValue) => {
  if (newValue) {
    globalStore.stepTwo.deliveryData.firstname = ''
    globalStore.stepTwo.deliveryData.lastname = ''
  }
})

function updatedCheckbox (newValue) {
  globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient = newValue

  if (!newValue) {
    globalStore.stepTwo.deliveryData.firstname = globalStore.stepTwo.personalData.firstname
    globalStore.stepTwo.deliveryData.lastname = globalStore.stepTwo.personalData.lastname
  }
}
</script>

<template>
  <div class="form-view--step">
    <div class="form-view--step-header">
      <h2>{{ $t('stepTwo.title') }}</h2>
      <span>{{ $t('stepTwo.description') }}</span>
    </div>
    <div class="form-view--step-content">
      <div class="form-view--step-content-section form">
        <span class="form-view--step-content-section-title bold">{{ $t('stepTwo.personalData.label') }}</span>
        <CustomInput v-model="globalStore.stepTwo.personalData.email" :required="true" :type="'email'" :placeholder-label="$t('stepTwo.personalData.email')" :id="'reward-campaign-step-2-personal-data-email'" />
        <CustomInput v-model="globalStore.stepTwo.personalData.firstname" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.personalData.firstname')" :id="'reward-campaign-step-2-personal-data-firstname'" />
        <CustomInput v-model="globalStore.stepTwo.personalData.lastname" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.personalData.lastname')" :id="'reward-campaign-step-2-personal-data-lastname'" />
        <CustomInput v-model="globalStore.stepTwo.personalData.phone" :required="false" :type="'text'" :placeholder-label="$t('stepTwo.personalData.phone')" :id="'reward-campaign-step-2-personal-data-phone'" />
      </div>
      <div class="form-view--step-content-section">
        <span class="form-view--step-content-section-title bold">{{ $t('stepTwo.deliveryData.label') }}</span>
        <CustomInput v-model="globalStore.stepTwo.deliveryData.company" :required="false" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.company')" :id="'reward-campaign-step-2-delivery-data-company'" />
        <CustomInput :is-disabled="!globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient" v-model="globalStore.stepTwo.deliveryData.firstname" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.firstname')" :id="'reward-campaign-step-2-delivery-data-firstname'" />
        <CustomInput :is-disabled="!globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient" v-model="globalStore.stepTwo.deliveryData.lastname" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.lastname')" :id="'reward-campaign-step-2-delivery-data-lastname'" />
        <CustomCheckbox @updated="updatedCheckbox($event)" :checked="globalStore.stepTwo.deliveryData.isOtherDeliveryRecipient" :label="$t('stepTwo.deliveryData.isDeliveryRecipientOtherLabel')" :required="false" :id="'reward-campaign-step-2-delivery-data-isDeliveryRecipientOtherLabel'" />
        <CustomInput v-model="globalStore.stepTwo.deliveryData.street" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.street')" :id="'reward-campaign-step-2-delivery-data-street'" />
        <CustomInput v-model="globalStore.stepTwo.deliveryData.houseNo" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.houseNo')" :id="'reward-campaign-step-2-delivery-data-house-no'" />
        <CustomInput v-model="globalStore.stepTwo.deliveryData.zip" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.zip')" :id="'reward-campaign-step-2-delivery-data-zip'" />
        <CustomInput v-model="globalStore.stepTwo.deliveryData.city" :required="true" :type="'text'" :placeholder-label="$t('stepTwo.deliveryData.city')" :id="'reward-campaign-step-2-delivery-data-city'" />
      </div>
    </div>
  </div>
</template>
